import { AnyAction } from '@reduxjs/toolkit'
import { Button } from 'primereact/button'
import React, { Dispatch, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { fetchGameCodeRequest } from '../../../redux/actions/gameActions'
import { GameState } from '../../../redux/types/game'
import { getGameSelector } from './../../../redux/selectors/gameSelectors'
import QRCode from 'qrcode.react'
import LoadingSpinner from './../../../components/LoadingSpinner'
import clickSoundEffect from '../../../assets/audio/click2.wav'
// import { useTranslation } from 'react-i18next'
import useSound from 'use-sound'
import { useTranslation } from 'react-i18next'

const QRCodeLogin = () => {
  // const [teamNameValue, setTeamNameValue] = useState('')
  // const [selectedLanguage, setSelectedLanguage] = useState<any>(null)
  const {
    data: { gameCode, volumeGlobal, branding },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()
  // const { i18n } = useTranslation()
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const { t } = useTranslation()

  useEffect(() => {
    dispatch(fetchGameCodeRequest())
  }, [])

  // const onLanguageChange = (e: { value: any }) => {
  //   // setSelectedLanguage(e.value)
  //   dispatch({ type: CHANGE_SELECTED_LANGUAGE, payload: e.value })
  //   i18n.changeLanguage(e.value.code.toLowerCase())
  // }

  return (
    <div
      style={{ width: '100%', height: '100vh' }}
      className="flex flex-column align-items-center"
    >
      <div
        style={{
          width: '100%',
          height: '20vh',
          background: branding?.steps.backgroundColor,
        }}
        className="flex justify-content-center align-items-center"
      >
        <h4
          className="zoominleft animation-duration-1000"
          style={{ color: branding?.steps.textColor, marginTop: '-15%' }}
        >
          {t('Step')} 3/3
        </h4>
      </div>
      <div
        style={{
          // width: '90%',
          // borderTopRightRadius: '50%',
          // borderTopLeftRadius: '50%',
          borderRadius: '27px',
          marginTop: '-20%',
          background: ' #fff',
          height: '90vh',
          // padding: '4vw',
          width: '100%',
        }}
        className="flex justify-content-center"
      >
        {/* <div className="w-full flex align-items-center justify-content-center"> */}
        <div
          style={{ width: '90%' }}
          className="flex flex-column align-items-center justify-content-evenly text-center"
        >
          <div className="flex flex-column align-items-center">
            <div>
              {/* </div> */}
              {gameLoading.isCheckingGameCode ? (
                <LoadingSpinner />
              ) : (
                gameCode && (
                  <QRCode
                    id="123456"
                    value={`${window.location.hostname}/qr-code-login-validate/${gameCode}`}
                    // value="123456"
                    size={290}
                    level={'H'}
                    includeMargin={true}
                    className="fadeindown animation-duration-1000"
                  />
                )
              )}
              {/* <Link className="p-button mt-4" to="/add-team-name">
            Next
          </Link> */}
              <h3
                className="my-5 fadeinup animation-duration-1000"
                style={{ color: '#333' }}
              >
                {t('ScanQRCodeTitle')}
              </h3>
              <p className="fadeinup animation-duration-1000">
                {t('ScanQRCode')}
              </p>
            </div>

            {/* <a onClick={downloadQR}> Download QR </a> */}
            <Button
              label={t('Finish')}
              onClick={() => {
                clickSound()
                navigate('/instructions')
              }}
              type="button"
              icon={
                <>
                  <div
                    className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                    style={{
                      backgroundColor: branding?.buttonPrimary.textColor,
                    }}
                  >
                    {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                  </div>
                  <i
                    className="pi pi-check icon-center"
                    style={{
                      color: branding?.buttonPrimary.backgroundColor,
                    }}
                  ></i>
                  {/* <ArrowRight
                    color="#fff"
                    // variant="Bold"
                    className="icon-center"
                    // className="p-button-icon p-c p-button-icon-right"
                  /> */}
                </>
              }
              className="p-button-rounded mt-3 py-3 zoominleft animation-duration-1000 uppercase w-full"
              style={{
                backgroundColor: branding?.buttonPrimary.backgroundColor,
                color: branding?.buttonPrimary.textColor,
              }}
              // className="p-button-rounded w-full mt-3 zoominleft animation-duration-1000"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default QRCodeLogin
